<div class="detail-container">
  <nb-card [nbSpinner]="!!(loading$|async)">
    <nb-card-header>
      <button nbButton ghost status="primary" (click)="navigateBack()">
        <nb-icon pack="eva" icon="arrow-back-outline"></nb-icon>
      </button>
      <h5>Rolle</h5>
      <wr-edit-delete-button-group *ngIf="canEdit() && !isNew()" (edit)="onEdit()" (delete)="onDelete()"></wr-edit-delete-button-group>
    </nb-card-header>
    <nb-card-body>
      <ng-container *ngIf="form">
        <nb-tabset>
          <nb-tab tabTitle="Details">
            <hau-form [formGroup]="form">
              <hau-form-field label="Name" [validation]="form.validation.name" cols="6">
                <input nbInput fullWidth formControlName="name">
              </hau-form-field>
              <hau-form-field label="Farbe" [validation]="form.validation.color" cols="6">
                <wr-color-preset-picker formControlName="color"></wr-color-preset-picker>
              </hau-form-field>
              <hau-form-field label="Wichtigkeit" [validation]="form.validation.weight" cols="6">
                <input nbInput fullWidth type="number" formControlName="weight">
              </hau-form-field>
              <hau-form-field label="Beschreibung" [validation]="form.validation.description" cols="6">
                <textarea nbInput fullWidth formControlName="description"></textarea>
              </hau-form-field>
            </hau-form>
          </nb-tab>
          <nb-tab tabTitle="Berechtigungen">
            <hau-form [formGroup]="form">
              <hau-form-field label="Berechtigungen" [validation]="form.validation.privileges">
                <ng-container *ngIf="config() as cfg">
                  <wr-privilege-hierarchy-control
                    [privilegeHierarchy]="cfg.privilegeHierarchy"
                    [allowedPrivileges]="cfg.allowedPrivileges"
                    formControlName="privileges"
                  >
                  </wr-privilege-hierarchy-control>
                </ng-container>
              </hau-form-field>
            </hau-form>
          </nb-tab>
          <nb-tab tabTitle="Benutzer">
            <hau-form [formGroup]="form">
              <hau-form-field>
                <wr-user-pick-list
                  [getAssignmentTypeFunction]="assignmentTypeFunction"
                  formControlName="users">
                </wr-user-pick-list>
              </hau-form-field>
            </hau-form>
          </nb-tab>
        </nb-tabset>
      </ng-container>
    </nb-card-body>
    <nb-card-footer *ngIf="canEdit()">
      <button size="medium" [disabled]="!isEditing" nbButton status="primary" (click)="submit()">Speichern</button>
      <button size="medium" [disabled]="!isEditing" nbButton status="basic" (click)="cancel()">Zurück</button>
    </nb-card-footer>
  </nb-card>
</div>
